"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBackgroundFilter = exports.transformVideo = exports.initializeBackgroundFilter = exports.getVFXConfig = exports.clearBackgroundFilter = void 0;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var chimeLogger = new _amazonChimeSdkJs.ConsoleLogger('chimeBlurLogger', _amazonChimeSdkJs.LogLevel.INFO);
var videoFxProcessor = null;

/**
 * Checks if the browser supports background filter feature
 * @returns {Promise<boolean>}
 */
var checkBrowserSupport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var isSupported;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return _amazonChimeSdkJs.VideoFxProcessor.isSupported(chimeLogger, false);
        case 1:
          isSupported = _context.v;
          if (isSupported) {
            _context.n = 2;
            break;
          }
          throw new Error("Background filter is not supported");
        case 2:
          return _context.a(2, isSupported);
      }
    }, _callee);
  }));
  return function checkBrowserSupport() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Preloads assets for background filter feature
 * @returns {Promise<void>}
 */
var preloadAssets = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return videoFxProcessor.loadAssets();
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function preloadAssets() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Initializes the background filter
 * @returns {Promise<void>}
 */
var initializeBackgroundFilter = exports.initializeBackgroundFilter = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          if (!videoFxProcessor) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          _context3.p = 1;
          videoFxProcessor = new _amazonChimeSdkJs.VideoFxProcessor(chimeLogger, 50);
          _context3.n = 2;
          return checkBrowserSupport();
        case 2:
          _context3.n = 3;
          return preloadAssets();
        case 3:
          _context3.n = 5;
          break;
        case 4:
          _context3.p = 4;
          _t = _context3.v;
          videoFxProcessor = null;
          chimeLogger.error("Error initializing background filter: ".concat(_t.message));
          throw new Error("Error initializing background filter: ".concat(_t.message));
        case 5:
          return _context3.a(2);
      }
    }, _callee3, null, [[1, 4]]);
  }));
  return function initializeBackgroundFilter() {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Creates a new transformed video device with background filter applied
 * @param videoInputId
 * @param videoFxConfig
 * @returns {Promise<DefaultVideoTransformDevice>}
 */
var transformVideo = exports.transformVideo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(videoInputId, videoFxConfig) {
    var transformedVideoDevice;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          if (!(videoFxProcessor === null)) {
            _context4.n = 1;
            break;
          }
          videoFxProcessor = new _amazonChimeSdkJs.VideoFxProcessor(chimeLogger, 50);
          _context4.n = 1;
          return preloadAssets();
        case 1:
          _context4.n = 2;
          return videoFxProcessor.setEffectConfig(videoFxConfig);
        case 2:
          transformedVideoDevice = new _amazonChimeSdkJs.DefaultVideoTransformDevice(chimeLogger, videoInputId, [videoFxProcessor]);
          transformedVideoDevice.framerate = 30;
          chimeLogger.info("Video input transformed with background filter: ".concat(JSON.stringify({
            videoInputId: videoInputId,
            videoFxConfig: videoFxConfig
          })));
          return _context4.a(2, transformedVideoDevice);
      }
    }, _callee4);
  }));
  return function transformVideo(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Clears the background filter from the transformed video input
 * Actually stops the transformed video input and sets the videoFxProcessor to null
 * @param transformedVideoInput
 * @returns {Promise<void>}
 */
var clearBackgroundFilter = exports.clearBackgroundFilter = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(transformedVideoInput) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          if (videoFxProcessor) {
            _context5.n = 1;
            break;
          }
          chimeLogger.error('No videoFxProcessor found');
          return _context5.a(2);
        case 1:
          _context5.n = 2;
          return transformedVideoInput.stop();
        case 2:
          videoFxProcessor = null;
          chimeLogger.info('Clearing background filter');
        case 3:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return function clearBackgroundFilter(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Updates the background filter configuration
 * @param videoFxConfig
 * @returns {Promise<void>}
 */
var updateBackgroundFilter = exports.updateBackgroundFilter = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(videoFxConfig) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          if (videoFxProcessor) {
            _context6.n = 1;
            break;
          }
          chimeLogger.error('No videoFxProcessor found');
          return _context6.a(2);
        case 1:
          _context6.n = 2;
          return videoFxProcessor.setEffectConfig(videoFxConfig);
        case 2:
          chimeLogger.info("Updating background filter: ".concat(JSON.stringify(videoFxConfig)));
        case 3:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return function updateBackgroundFilter(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 *
 * @param filterType
 * @param backgroundImageURL
 * @returns {{backgroundReplacement: {defaultColor: string, isEnabled: boolean, backgroundImageURL: string}, backgroundBlur: {strength: string, isEnabled: boolean}}}
 */
var getVFXConfig = exports.getVFXConfig = function getVFXConfig(filterType) {
  var backgroundImageURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    backgroundBlur: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.BLUR,
      strength: 'high'
    },
    backgroundReplacement: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM,
      backgroundImageURL: backgroundImageURL,
      defaultColor: backgroundImageURL ? undefined : '#5C617C'
    }
  };
};